/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { OAuthClientUIConfiguration } from './OAuthClientUIConfiguration';
import {
    OAuthClientUIConfigurationFromJSON,
    OAuthClientUIConfigurationFromJSONTyped,
    OAuthClientUIConfigurationToJSON,
    OAuthClientUIConfigurationToJSONTyped,
} from './OAuthClientUIConfiguration';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface PutOauth2UiConfiguration201Response
 */
export interface PutOauth2UiConfiguration201Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof PutOauth2UiConfiguration201Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof PutOauth2UiConfiguration201Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {OAuthClientUIConfiguration}
     * @memberof PutOauth2UiConfiguration201Response
     */
    result: OAuthClientUIConfiguration;
}

/**
 * Check if a given object implements the PutOauth2UiConfiguration201Response interface.
 */
export function instanceOfPutOauth2UiConfiguration201Response(value: object): value is PutOauth2UiConfiguration201Response {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function PutOauth2UiConfiguration201ResponseFromJSON(json: any): PutOauth2UiConfiguration201Response {
    return PutOauth2UiConfiguration201ResponseFromJSONTyped(json, false);
}

export function PutOauth2UiConfiguration201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutOauth2UiConfiguration201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': OAuthClientUIConfigurationFromJSON(json['result']),
    };
}

export function PutOauth2UiConfiguration201ResponseToJSON(json: any): PutOauth2UiConfiguration201Response {
    return PutOauth2UiConfiguration201ResponseToJSONTyped(json, false);
}

export function PutOauth2UiConfiguration201ResponseToJSONTyped(value?: PutOauth2UiConfiguration201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': OAuthClientUIConfigurationToJSON(value['result']),
    };
}

